// React
import React from "react";

import './login.css';
import './exchanges.css';

export const Exchanges = () => {

    return (
        <div className="section" id="exchanges">

            <div className="section-title">Exchanges</div>

            <div className="section-content">  

                <div className="exchanges">

                    <div className="exchange">
                        <img src="https://s3-us-west-2.amazonaws.com/yety-app/app/exchanges/coinbase.png" alt="Coinbase" style={{width:'142px',height:'30px'}}></img>
                    </div>

                    <div className="exchange">
                        <img src="https://s3-us-west-2.amazonaws.com/yety-app/app/exchanges/bittrex.png" alt="BitTrex" style={{width:'130px'}}></img>
                    </div>

                    <div className="exchange">
                        <img src="https://s3-us-west-2.amazonaws.com/yety-app/app/exchanges/kraken.png" alt="Kraken" style={{width:'150px',height:'24px', marginTop:'6px'}}></img>
                    </div>

                    <div className="exchange">
                        <img src="https://s3-us-west-2.amazonaws.com/yety-app/app/exchanges/poloniex.png" alt="Poloniex" style={{width:'152px',height:'23px',marginTop:'6px'}}></img>
                    </div>

                </div>

            </div>

        </div>
    );

};


// WEBPACK FOOTER //
// ./src/Views/Login/Exchanges.js